module.exports = __webpack_public_path__ + "static/media/R-360HD.9702d011.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-360HD.png
// module id = 2106
// module chunks = 0